export const mapGridArea = ({ left, top, width, height, segments }) => {
    const dt = 12 / segments;

    return `${top * dt + 1} / ${left * dt + 1} / ${top * dt + height * dt + 1} / ${left * dt + width * dt + 1}`;
};
